import MapLibreGL from "maplibre-gl";

enum DotNetMethod {
    HandleLoad = "HandleLoad",
    HandleStyleData = "HandleStyleData"
}

type Entry = {
    map: MapLibreGL.Map;
    handleLoad: () => void;
    handleStyleData: () => void;
};

const registry = new Map<any, Entry>();

function initialize(dotNetHelper: any, options: MapLibreGL.MapOptions): MapLibreGL.Map {
    const map = new MapLibreGL.Map(options);

    const handleLoad = () => {
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleLoad)
    };

    const handleStyleData = () => {
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleStyleData);
    };

    map.on("load", handleLoad);
    map.on("styledata", handleStyleData);

    registry.set(dotNetHelper, {
        map,
        handleLoad,
        handleStyleData
    });

    return map;
}

function destroy(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { map, handleLoad, handleStyleData } = entry;

    map.off("load", handleLoad);
    map.off("styledata", handleStyleData);
    map.remove();

    dotNetHelper.dispose();

    registry.delete(dotNetHelper);
}

export default {
    initialize,
    destroy
}